import { Box, Paper, Typography } from "@mui/material";
import { ReactNode } from "react";

interface ChartCardProps {
  title: string;
  children: ReactNode;
}

const ChartCard = ({ title, children }: ChartCardProps) => (
  <Paper
    elevation={0}
    sx={{
      p: { xs: 1.5, lg: 2.5 },
      borderRadius: 3,
      border: "1px solid #E8EBF0",
      bgcolor: "#fff",
    }}
  >
    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
      <Typography variant="subtitle1" fontWeight={600} sx={{ color: "#1B2559" }}>
        {title}
      </Typography>
    </Box>
    {children}
  </Paper>
);

export default ChartCard;
